import React, { FC, ReactNode, useMemo } from "react"
import { Panel, Radio, Title, Statistics } from "dash-styled"

import {
    getQualityDisplayName,
    MetricRequest
} from "../../../../../../../../../../../../Models/Client/MetricRequest"
import { APIAppPlan } from "../../../../../../../../../../../../Models/API/APIAppPlans"

interface PlanPanelProps {
    className?: string
    model: APIAppPlan
    metric?: MetricRequest
    priceOverride?: number
    qualityName?: string
    isSelected: boolean
    footer?: ReactNode
    onSelect: () => void
}

export const PlanPanel: FC<PlanPanelProps> = ({
    className,
    model,
    metric,
    priceOverride,
    qualityName,
    isSelected,
    footer,
    onSelect
}) => {
    const price = priceOverride ?? metric?.cost
    const quality = useMemo(
        () =>
            metric !== undefined && qualityName !== undefined
                ? {
                      value: metric.quality[qualityName]?.value,
                      name: getQualityDisplayName(metric, qualityName)
                  }
                : undefined,
        [metric, qualityName]
    )

    return (
        <Panel
            size="sm"
            noPadding={true}
            className={className}
            borderColor={isSelected ? "pink" : undefined}
            testId="plan-card"
        >
            <Radio
                className="p-4 pl-5 w-full"
                color="violet"
                isChecked={isSelected}
                onChange={onSelect}
            >
                <div className="w-full ml-2 flex flex-col xl:flex-row">
                    <div className="w-full xl:w-1/2 flex flex-col justify-center">
                        <Title
                            component="h5"
                            variant="heading4"
                            noMargin={true}
                        >
                            {model.metadata?.name}
                        </Title>
                        {model.metadata !== null &&
                            model.metadata.description !== undefined && (
                                <p className="mt-2 text-smoke-350">
                                    {model.metadata.description}
                                </p>
                            )}
                    </div>
                    {quality === undefined && price === undefined ? null : (
                        <div className="w-full flex items-center mt-2 xl:mt-0 xl:w-1/2">
                            {quality !== undefined && (
                                <Statistics
                                    testId="plan-quality"
                                    className="w-0 flex-grow mx-2"
                                    align="horizontal"
                                    value={quality.value}
                                    label={
                                        <>
                                            Average
                                            <br />
                                            {quality.name}
                                        </>
                                    }
                                />
                            )}
                            {price !== undefined && (
                                <Statistics
                                    testId="plan-cost"
                                    className="w-0 flex-grow mx-2"
                                    align="horizontal"
                                    value={`$${price}`}
                                    label={
                                        <>
                                            Per data
                                            <br />
                                            point
                                        </>
                                    }
                                />
                            )}
                        </div>
                    )}
                </div>
            </Radio>
            {footer}
        </Panel>
    )
}
